export default "__VITE_ASSET__f7RNI$Aa__"